var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ fontWeight: _vm.option.fontWeightText || 400 }),domProps:{"innerHTML":_vm._s(_vm.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }